import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { Box } from '@mui/material';

import { SURFACE_RADIUS } from '~/theme';

export const CARD_SX = {
  bgcolor: '#fff',
  border: '1px solid #e1e5ea',
  borderRadius: `${SURFACE_RADIUS}px`,
  p: '20px',
} as const;

export const CARD_TITLE_SX = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: '.06em',
  color: '#555',
} as const;

export function EvidenceIcon({ fileType, size = 30 }: { fileType: string; size?: number }) {
  const Icon =
    fileType === 'image'
      ? ImageOutlinedIcon
      : fileType === 'spreadsheet'
        ? TableChartOutlinedIcon
        : PictureAsPdfOutlinedIcon;
  return (
    <Box
      component="span"
      sx={{
        width: size,
        height: size,
        flex: 'none',
        borderRadius: '6px',
        bgcolor: '#f1f3f6',
        color: '#555',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon sx={{ fontSize: Math.round(size * 0.6) }} />
    </Box>
  );
}
